import { useEffect, useState } from 'react';

import { NextParsedUrlQuery } from 'next/dist/server/request-meta';
import { useRouter } from 'next/router';

import { BfwUserContextService } from 'generatedBfw/static';

interface ArtQuery extends NextParsedUrlQuery {
  art: string;
}

/**
 * Fetches merchantId for the given art. If merchantId is returned then also a merchant_id cookie is set by the backend response.
 * @returns merchantId for the given art or null if no art is provided in query
 */
export const useArtQuery = () => {
  const { query } = useRouter();
  const { art } = query as ArtQuery;

  const [artParam, setArtParam] = useState<string>('');
  const [merchantId, setMerchantId] = useState<string | null>('');

  if (art && art !== artParam) {
    setArtParam(art);
  }

  useEffect(() => {
    const getMerchantId = async () => {
      const merchantResponse = await BfwUserContextService.getMerchantId(artParam);
      setMerchantId(merchantResponse.merchantId);
    };

    if (artParam) {
      getMerchantId();
    } else {
      setMerchantId(null);
    }
  }, [artParam]);

  return { merchantId };
};
